import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { get } from 'lodash';

import UtilService from 'services/util';

import IntlMessages from 'util/IntlMessages';

import { commonLogout, LOCAL_STORAGE_VAR } from 'constants/Common';

import HeaderStrip from '../common/Header/HeaderStrip';

import 'react-tippy/dist/tippy.css';

class MobileSidebar extends Component {
  constructor() {
    super();
    this.state = {
      visible: true,
      visible1: false,
      visible2: false,
      visible3: false,
    };
  }
  submenu = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };
  submenu1 = () => {
    this.setState({
      visible1: !this.state.visible1,
    });
  };
  submenu2 = () => {
    this.setState({
      visible2: !this.state.visible2,
    });
  };
  submenu3 = () => {
    this.setState({
      visible3: !this.state.visible3,
    });
  };
  render() {
    const pathname = window.location.pathname;

    const USER_PERMIT = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-userPermissions`);
    return (
      <div className="headerMenuBox">
        <div className="headerMeniInner">
          <HeaderStrip />
          <ul id="links" className="">
            {get(USER_PERMIT, 'DASHBOARD.view', false) && (
              <li className={'d-flex align-items-center'}>
                <Link to="/dashboard" className={`menuItem ${pathname === `/dashboard` && `active`}`}>
                  <IntlMessages id="app.dashboard" />
                </Link>
              </li>
            )}
            {get(USER_PERMIT, 'SEARCH_DIAMOND.view', false) && (
              <li className={'d-flex align-items-center'}>
                <Link to="/diamond-search" className={`menuItem ${pathname === `/diamond-search` && `active`}`}>
                  <IntlMessages id="app.Search" />
                  {/* Search */}
                </Link>
              </li>
            )}
            {get(USER_PERMIT, 'QUICK_SEARCH.view', false) && (
              <li className={'d-flex align-items-center'}>
                <Link to="/quick-search" className={`menuItem ${pathname === `/quick-search` && `active`}`}>
                  <IntlMessages id="app.quick-search" />
                </Link>
              </li>
            )}
            {/* {get(USER_PERMIT, 'BID.view', false) && (
              <li>
                <Link className={`menuItem ${pathname === `/new-arrival-bid-it` && `active`}`} to="/new-arrival-bid-it">
                  <IntlMessages id="app.newArrival" />
                </Link>
              </li>
            )} */}
            {/* {get(USER_PERMIT, 'EXCLUSIVE.view', false) && (
              <li>
                <Link className={`menuItem ${pathname === `/special-stone` && `active`}`} to="/special-stone">
                  <IntlMessages id="app.DiamNowExclusive" />
                </Link>
              </li>
            )}
            {get(USER_PERMIT, 'STONE_OF_THE_DAY.view', false) && (
              <li>
                <Link className={`menuItem ${pathname === `/stone-of-the-day` && `active`}`} to="/stone-of-the-day">
                  <IntlMessages id="app.stoneOfTheDay" />
                </Link>
              </li>
            )} */}
            {get(USER_PERMIT, 'MATCH_PAIR.view', false) && (
              <li className={'d-flex align-items-center'}>
                <Link to="/search-match-pair" className={`menuItem ${pathname === `/search-match-pair` && `active`}`}>
                  <IntlMessages id="app.matchpairDashboard" />
                </Link>
              </li>
            )}
            {get(USER_PERMIT, 'UPCOMING.view', false) && (
              <li>
                <Link className={`menuItem ${pathname === `/upcoming` && `active`}`} to="/upcoming">
                  <IntlMessages id="app.Upcoming" />
                </Link>
              </li>
            )}
            <li>
              <Link className="menuItem" to="/account">
                <IntlMessages id="app.myAccount" />
              </Link>
            </li>
            {/* <li>
              <Link className="menuItem" to="/contact-us">
                Contact Us
              </Link>
            </li> */}
            <li onClick={commonLogout}>
              <a>Log Out</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

// export default withRouter(Sidebar);
const mapStateToProps = (props) => props;
export default connect(mapStateToProps)(withRouter(MobileSidebar));
